import React, { useEffect, useState } from "react";
import PageWrapper from "../SignupPages/PageWrapper";
import { useNavigate } from "react-router-dom";
import Alert from "../../assets/images/alert.png";
import "./IntakeFormPagesCommon.css";
import { findExistPatient } from "../../services/api";

const IntakeFormPage1: React.FC = () => {
  const [uuidValue, setUuidValue] = useState<string>("");
  const navigate = useNavigate();
  const [email, setEmail] = useState<string>("");
  const [emailError, setEmailError] = useState<string>("");
  const [err, setErr] = useState<string>("");
  useEffect(() => {
    const getItem = localStorage.getItem("uuid");
    if (getItem) {
      setUuidValue(JSON.parse(getItem).value);
    }
  });

  const handleNext = async () => {
    if (!isValidEmail(email)) {
      setEmailError(
        "Invalid email address. Please enter a valid email address."
      );
      return;
    } else {
      setEmailError("");
    }

    if (email) {
      localStorage.setItem(
        "email",
        JSON.stringify({ key: "email", value: email })
      );
    }

    try {
      const productCategory = "GLP1";
      const encodedEmail = encodeURIComponent(email);
      const response = await findExistPatient(encodedEmail, productCategory);

      if (response?.error?.includes("No active subscriptions")) {
        navigate("/");
        localStorage.clear();
        return;
      }

      if (response?.error?.includes("User not found")) {
        navigate("/");
        localStorage.clear();
        return;
      }

      const userData = response?.user?.[0];
      const intakeFormStatus = response?.intake_form;
      const productNames = response?.product_names || [];
      const matchedProducts = productNames.find((name : string) => name.includes("Semaglutide") || name.includes("Tirzepatide"))
      const rawProductName = matchedProducts || "";
      const parsedItemName = rawProductName.split("(")[0].trim();
      const medicationTypeMatch = rawProductName.match(/\(([^)]+)\)/);
      const medicationType = medicationTypeMatch?.[1] || "";

      localStorage.setItem(
        "itemName",
        parsedItemName )
      ;
      localStorage.setItem(
        "medicationType",
       medicationType
      );

      localStorage.setItem(
        "intakeFormStatus",
        JSON.stringify({ key: "intakeFormStatus", value: intakeFormStatus })
      );

      if (userData) {
        localStorage.setItem(
          "firstName",
          JSON.stringify({ key: "firstName", value: userData.fname || "" })
        );
        localStorage.setItem(
          "lastName",
          JSON.stringify({ key: "lastName", value: userData.lname || "" })
        );
        localStorage.setItem(
          "email",
          JSON.stringify({ key: "email", value: userData.email || "" })
        );
        localStorage.setItem(
          "phone",
          JSON.stringify({ key: "phone", value: userData.phone || "" })
        );
        if(userData?.addressLineOne){
          localStorage.setItem(
                  "disable_address",
                  JSON.stringify({ key: "disable_address", value: true })
                );
        }else {
          localStorage.setItem(
            "disable_address",
            JSON.stringify({ key: "disable_address", value: false })
          );
        }
        localStorage.setItem(
          "addressLine1",
          JSON.stringify({
            key: "addressLine1",
            value: userData.addressLineOne || "",
          })
        );
        localStorage.setItem(
          "addressLine2",
          JSON.stringify({
            key: "addressLine2",
            value: userData?.addressLineTwo || "",
          })
        );
        localStorage.setItem(
          "city",
          JSON.stringify({ key: "city", value: userData?.city || "" })
        );
        localStorage.setItem(
          "state",
          JSON.stringify({ key: "state", value: userData?.state || "" })
        );
        localStorage.setItem(
          "zip",
          JSON.stringify({ key: "zip", value: userData?.zipCode || "" })
        );
        localStorage.setItem(
          "state",
          JSON.stringify({
            key: "state",
            value: userData.state || "",
          })
        );
      }

      if (intakeFormStatus === true) {
        navigate("/email-check2");
      } else {
        navigate("/email-check1");
      }
    } catch (error: unknown) {
      const errorMessage =
        error instanceof Error ? error?.message : String(error);
      console.log(errorMessage);
    }
  };
  useEffect(() => {
    const savedEmail = localStorage.getItem("email");
    if (savedEmail) {
      const parsedEmail = JSON.parse(savedEmail);
      setEmail(parsedEmail.value);
    }
  }, []);
  const isValidEmail = (email: string): boolean => {
    const emailPattern = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/;
    return emailPattern.test(email);
  };

  const styles = {
    container: {
      maxWidth: "500px",
      margin: "0 auto",
    },
    content: {
      marginTop: "20px",
    },
    label: {
      marginBottom: "10px",
      fontWeight: "bold",
    },
    inputContainer: {
      marginBottom: "20px",
    },
    input: {
      width: "560px",
      height: "52px",
      padding: "10px",
      fontSize: "16px",
      border: "1px solid #D9D9D9",
      borderRadius: "154px",
      background: "#FFF",
    },
    button: {
      backgroundColor: "#007bff",
      color: "white",
      padding: "10px 20px",
      border: "none",
      borderRadius: "4px",
      cursor: "pointer",
      fontSize: "16px",
      marginTop: "20px",
    },
    disabledButton: {
      backgroundColor: "#ccc",
      cursor: "not-allowed",
    },

    checkboxContainer: {
      display: "flex",
      alignItems: "center",
    },
    loader: {
      border: "4px solid #f3f3f3",
      borderTop: "4px solid #3498db",
      borderRadius: "50%",
      width: "20px",
      height: "10px",
      animation: "spin 1s linear infinite",
    },
  };

  const inputError = (errorMessage: string) => {
    if (!errorMessage) return null;
    return (
      <div
        className="checkout-state-error"
        style={{ marginTop: "20px", borderRadius: "154px" }}
      >
        <img src={Alert} alt="state-error" width={"16px"} height={"15px"} />
        <p className="checkout-state-error-text">{errorMessage}</p>
      </div>
    );
  };

  return (
    <PageWrapper>
      <div className="signup-page-container">
        <div className="signup-content">
          <p className="intake-form-content-header">Welcome back,</p>

          <p className="intake-form-content-subheader">
            please enter your email ID
          </p>

          <div style={styles.inputContainer}>
            <input
              type="email"
              value={email}
              onChange={(e) => {
                setEmail(e.target.value);
                setEmailError("");
                setErr("");
              }}
              placeholder="Email"
              className="input-fields"
            />
            {emailError && inputError(emailError)}
          </div>

          {err && inputError(err)}
          <button
            onClick={handleNext}
            disabled={!email}
            className="next-btn sticky-btn"
            style={{
              backgroundColor: !email ? "#d3d3d3" : "#0c3972",
            }}
          >
            {"Next →"}
          </button>
        </div>
      </div>
    </PageWrapper>
  );
};

export default IntakeFormPage1;
